/* GLDN - Complete the Look: Shopify Search & Discovery + drawer */
(() => {
  const ROOT = window.Shopify?.routes?.root || '/';
  const SELECTOR = 'product-recommendations.m-complementary-products';
  const formatPrice = cents => new Intl.NumberFormat('pl-PL', {
    style: 'currency', currency: 'PLN'
  }).format(Number(cents || 0) / 100);
  let drawer, overlay, opener;

  function elements() {
    if (drawer) return;
    overlay = document.createElement('div');
    overlay.className = 'gldn-look-overlay';
    overlay.hidden = true;
    drawer = document.createElement('aside');
    drawer.className = 'gldn-look-drawer';
    drawer.setAttribute('role', 'dialog');
    drawer.setAttribute('aria-modal', 'true');
    drawer.setAttribute('aria-label', 'Complete the Look');
    drawer.setAttribute('aria-hidden', 'true');
    drawer.innerHTML = `
      <div class="gldn-look-head">
        <strong>STWÓRZ ZESTAW</strong>
        <button type="button" class="gldn-look-close" aria-label="Zamknij">&times;</button>
      </div>
      <div class="gldn-look-items" aria-live="polite"></div>
      <div class="gldn-look-footer">
        <div class="gldn-look-total-row"><span>Razem</span><strong class="gldn-look-total">0,00 zł</strong></div>
        <p class="gldn-look-message" role="status"></p>
        <button type="button" class="gldn-look-add" disabled>DODAJ WYBRANE DO KOSZYKA</button>
      </div>`;
    document.body.append(overlay, drawer);
    overlay.addEventListener('click', closeDrawer);
    drawer.querySelector('.gldn-look-close').addEventListener('click', closeDrawer);
    drawer.querySelector('.gldn-look-add').addEventListener('click', addSelected);
    drawer.addEventListener('change', updateTotal);
    drawer.addEventListener('click', event => {
      const option = event.target.closest('.gldn-look-size');
      if (!option) return;
      const item = option.closest('.gldn-look-item');
      item.dataset.variant = option.dataset.variant;
      item.dataset.price = option.dataset.price;
      item.querySelector('.gldn-look-check').checked = true;
      item.querySelector('.gldn-look-item-price').textContent = formatPrice(option.dataset.price);
      item.querySelectorAll('.gldn-look-size').forEach(button => {
        button.classList.toggle('is-active', button === option);
        button.setAttribute('aria-pressed', String(button === option));
      });
      updateTotal();
    });
    document.addEventListener('keydown', event => {
      if (!drawer.classList.contains('is-open')) return;
      if (event.key === 'Escape') closeDrawer();
      if (event.key === 'Tab') {
        const focusable = [...drawer.querySelectorAll('button:not(:disabled), input:not(:disabled), a[href]')];
        if (!focusable.length) return;
        const first = focusable[0], last = focusable[focusable.length - 1];
        if (event.shiftKey && document.activeElement === first) {
          event.preventDefault(); last.focus();
        } else if (!event.shiftKey && document.activeElement === last) {
          event.preventDefault(); first.focus();
        }
      }
    });
  }

  function closeDrawer() {
    if (!drawer) return;
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    overlay.hidden = true;
    document.body.classList.remove('gldn-look-locked');
    opener?.focus();
  }

  function updateTotal() {
    if (!drawer) return;
    const selected = [...drawer.querySelectorAll('.gldn-look-item')]
      .filter(item => item.querySelector('.gldn-look-check').checked);
    const missingSize = selected.some(item => !item.dataset.variant);
    const sum = selected.reduce((amount, item) =>
      amount + (item.dataset.variant ? Number(item.dataset.price || 0) : 0), 0);
    drawer.querySelector('.gldn-look-total').textContent = formatPrice(sum);
    drawer.querySelector('.gldn-look-add').disabled = !selected.length || missingSize;
    drawer.querySelector('.gldn-look-message').textContent = missingSize
      ? 'Wybierz rozmiar dla zaznaczonych produktów.' : '';
  }

  function productCard(product) {
    const available = (product.variants || []).filter(variant => variant.available);
    if (!available.length) return null;
    const singleVariant = product.variants.length === 1;
    const chosen = singleVariant ? available[0] : null;
    const item = document.createElement('article');
    item.className = 'gldn-look-item';
    item.dataset.variant = chosen ? String(chosen.id) : '';
    item.dataset.price = String(chosen ? chosen.price : available[0].price);

    const image = document.createElement('img');
    image.className = 'gldn-look-photo';
    image.alt = product.title;
    image.loading = 'lazy';
    if (product.featured_image) image.src = product.featured_image;

    const details = document.createElement('div');
    details.className = 'gldn-look-details';
    const title = document.createElement('div');
    title.className = 'gldn-look-name';
    title.textContent = product.title;
    const price = document.createElement('div');
    price.className = 'gldn-look-item-price';
    price.textContent = formatPrice(available[0].price);
    const selectLabel = document.createElement('label');
    selectLabel.className = 'gldn-look-checkbox-row';
    const checkbox = document.createElement('input');
    checkbox.type = 'checkbox';
    checkbox.className = 'gldn-look-check';
    selectLabel.append(checkbox, document.createTextNode(' Dodaj do zestawu'));
    details.append(title, price);
    if (!singleVariant) {
      const label = document.createElement('p');
      label.className = 'gldn-look-size-label';
      label.textContent = 'WYBIERZ WARIANT';
      const sizes = document.createElement('div');
      sizes.className = 'gldn-look-sizes';
      available.forEach(variant => {
        const button = document.createElement('button');
        button.type = 'button';
        button.className = 'gldn-look-size';
        button.textContent = variant.title;
        button.dataset.variant = variant.id;
        button.dataset.price = variant.price;
        button.setAttribute('aria-pressed', 'false');
        sizes.append(button);
      });
      details.append(label, sizes);
    }
    details.append(selectLabel);
    item.append(image, details);
    return item;
  }

  async function openDrawer(root, button) {
    elements();
    opener = button;
    overlay.hidden = false;
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    document.body.classList.add('gldn-look-locked');
    drawer.querySelector('.gldn-look-close').focus();
    drawer.querySelector('.gldn-look-add').disabled = true;
    drawer.querySelector('.gldn-look-total').textContent = formatPrice(0);
    drawer.querySelector('.gldn-look-message').textContent = '';
    const list = drawer.querySelector('.gldn-look-items');
    list.textContent = 'Ładowanie produktów…';

    const handles = [...new Set([...root.querySelectorAll('.m-product-card__link')]
      .map(link => link.getAttribute('href')?.match(/\/products\/([^/?#]+)/)?.[1])
      .filter(Boolean))];
    if (!handles.length) {
      list.textContent = 'Brak dostępnych produktów do zestawu.';
      return;
    }
    try {
      const products = await Promise.all(handles.map(async handle => {
        const response = await fetch(`${ROOT}products/${encodeURIComponent(handle)}.js`);
        if (!response.ok) throw new Error('Nie udało się pobrać produktu.');
        return response.json();
      }));
      list.replaceChildren(...products.map(productCard).filter(Boolean));
      if (!list.children.length) list.textContent = 'Produkty są obecnie niedostępne.';
      updateTotal();
    } catch (error) {
      list.textContent = 'Nie udało się pobrać produktów. Spróbuj ponownie.';
    }
  }

  async function addSelected() {
    const items = [...drawer.querySelectorAll('.gldn-look-item')]
      .filter(item => item.querySelector('.gldn-look-check').checked)
      .map(item => ({ id: Number(item.dataset.variant), quantity: 1 }));
    if (!items.length || items.some(item => !item.id)) return;
    const button = drawer.querySelector('.gldn-look-add');
    const message = drawer.querySelector('.gldn-look-message');
    button.disabled = true;
    button.textContent = 'DODAWANIE…';
    try {
      const response = await fetch(`${ROOT}cart/add.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items })
      });
      if (!response.ok) {
        const error = await response.json().catch(() => ({}));
        throw new Error(error.description || error.message || 'Nie udało się dodać produktów.');
      }
      

      // Odśwież natywny koszyk Minimog bez przeładowania strony
      try {
        const cartDrawerBody = document.getElementById('MinimogCartDrawerBody');

        if (
          cartDrawerBody &&
          typeof cartDrawerBody.onCartRefresh === 'function'
        ) {
          await cartDrawerBody.onCartRefresh({
            detail: { open: false }
          });
        } else {
          document.dispatchEvent(
            new CustomEvent('cart:refresh', {
              detail: { open: false }
            })
          );
        }
      } catch (cartError) {
        console.warn('GLDN: błąd odświeżania koszyka:', cartError);
      }

      message.classList.add('is-success');
      message.textContent = 'Produkty zostały dodane do koszyka.';
      button.textContent = 'DODANO DO KOSZYKA ✓';
      button.disabled = true;

    } catch (error) {
      message.textContent = error.message;
      button.textContent = 'DODAJ WYBRANE DO KOSZYKA';
      updateTotal();
    }
  }

  function enhance() {
    document.querySelectorAll(SELECTOR).forEach(root => {
      if (root.querySelector('.gldn-look-open')) return;
      if (!root.querySelector('.m-product-card__link')) return;

      const button = document.createElement('button');
      button.type = 'button';
      button.className = 'gldn-look-open';
      button.textContent = 'WYBIERZ PRODUKTY DO ZESTAWU';
      button.addEventListener('click', () => openDrawer(root, button));

      root.append(button);
    });
  }

  function start() {
    enhance();

    const section = document.querySelector('.m-main-product') || document.body;

    new MutationObserver(enhance).observe(section, {
      childList: true,
      subtree: true
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();
